import React, { Suspense, useEffect, useLayoutEffect, useRef } from 'react';
import { usePathname } from 'expo-router';
import { useReadAloudStore } from '@/store/readAloud';
import { useAuthStore } from '@/store/auth';

const Session = React.lazy(() => import('./ReadAloudSession'));

export default function ReadAloudHost({ allowed = true }) {
  const session = useReadAloudStore(state => state.session);
  const pathname = usePathname();
  const previousPathname = useRef(pathname);
  const routeChanged = previousPathname.current !== pathname;
  // Own navigation here, outside the lazy session: leaving while the player is
  // still loading must cancel it too. Clear the composer controls before paint.
  useLayoutEffect(() => {
    if (previousPathname.current !== pathname) useReadAloudStore.getState().stop();
    previousPathname.current = pathname;
  }, [pathname]);
  useEffect(() => useAuthStore.subscribe((next, previous) => {
    if ((!next.token && previous.token) || next._isSigningOut ||
        next._sessionGeneration !== previous._sessionGeneration) {
      useReadAloudStore.getState().stop();
    }
  }), []);
  useEffect(() => { if (!allowed) useReadAloudStore.getState().stop(); }, [allowed]);
  return allowed && session && !routeChanged ? <Suspense fallback={null}><Session key={session.id} text={session.text} /></Suspense> : null;
}
